<template>
    <div class="text-center">
      <v-dialog v-model="dialog" max-width="700" persistent>
        <v-card>
          <v-card-title style="background: #e72152;" class="text-h5 darken-3 white--text">
            cerrar el programa 
          </v-card-title>
  
          <v-card-text>  
            <p class="text-center">
                {{ input.programa_nombre }}
            </p>
            <p>
                Funcionalidad en desarrollo, se debe cambiar la fase del programa en programas para que no se pueda seguir escribiendo
            </p>
            <v-progress-linear v-if="loading" class="mt-2" indeterminate/>
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn style="background: #00a082;" dark :disabled="loading" @click="enviar()"> confirmar </v-btn> -->
            <v-btn color="red" outlined @click="dialog = false"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>
  
<script>

export default {
    data() {
        return {
            loading: false,
            dialog: false, 
            input: {}
        };
    },
    methods: {
        async openmodal(row) {
            window.console.log('openmodal', row)
            this.input = row
            this.dialog = true
        },

        async enviar(){ },

        async aprobar(){ },

        async desaprobar(){ }
    }
};
</script>
  